import React, { Component } from 'react';
import Grow from '@mui/material/Grow';
import LinearProgress from '@mui/material/LinearProgress';
import MainStore from '../../../MainStore'

export default class ProjectSchedulleRow extends Component {

    constructor(props) {
        super(props);
        this.getSum = this.getSum.bind(this);
        this.state = {
            isOpen: false
        };

        this.loadPeopleInfo = this.loadPeopleInfo.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.viewType !== this.props.viewType) {
            this.setState({ isOpen: false });
            this.loadPeopleInfo();
        }
    }

    getSum() {
        var sum = this.props.works.reduce(((accumulator, w) => accumulator + w.minutes), 0);
        return (sum / 60).toFixed(2) + "ч";
    }

    loadPeopleInfo() {
        var scope = this;
        MainStore.setMaskVisible();
        fetch('api/Schedulle/ProjectDetail?projectId=' + this.props.value.id + '&viewType=' + this.props.viewType + '&start=' + (this.props.dates ? this.props.dates.start.toISOString() : ''), {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ people: result });
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        var sumByPeople = 0;
        if (this.state.people) {
            sumByPeople = this.state.people.reduce(((accumulator, w) => accumulator + w.minutes), 0);
        }
        return (
            <div>
                <div className="project-schedulle-row-caption clearfix">
                    <div className="project-schedulle-name" onClick={() => { this.setState({ isOpen: !this.state.isOpen }); !this.state.isOpen && this.loadPeopleInfo(); }}>{this.props.value.project}</div>
                    <div className="project-schedulle-time-left">{(this.props.value.factMinutes / 60).toFixed(2)}ч</div>
                    <div className="project-schedulle-time-right">{this.props.value.plan}ч</div>
                </div>
                <LinearProgress color={this.props.value.factMinutes > (this.props.value.plan * 60) ? "secondary" : "primary"} variant="determinate" value={100 * (this.props.value.factMinutes) / (this.props.value.plan * 60)} />
                <Grow in={this.state.isOpen}>
                    <div className={"project-schedulle-detail-block " + (this.state.isOpen ? "" : "null-height")}>
                        {this.state.people && this.state.people.map(p =>
                            <div>
                                {p.user} {p.sp}sp
                                <LinearProgress variant="determinate" value={100 * (p.minutes) / (sumByPeople)} />
                                {(p.minutes / 60).toFixed(2)}ч
                            </div>)}
                    </div>
                </Grow>
            </div>);
    }
}